import { __decorate } from "tslib";
import _ from 'lodash';
import dayjs from 'dayjs';
import { injectable } from 'inversify';
let DeployableManagementService = class DeployableManagementService {
    getOptionsProducts() {
        return [
            { text: 'ANALYTICS', value: 'ANALYTICS' },
            { text: 'WORKSPACE', value: 'WORKSPACE' },
            { text: 'EUREKA', value: 'EUREKA' },
            { text: 'BACKOFFICE', value: 'BACKOFFICE' }
        ];
    }
    getEnvironmentList() {
        return [
            { text: 'CI', value: 'CI', isProd: false },
            { text: 'QA', value: 'QA', isProd: false },
            { text: 'STAGE', value: 'STAGE', isProd: false },
            { text: 'CN', value: 'CN', isProd: true },
            { text: 'US', value: 'US', isProd: true },
            { text: 'EU', value: 'EU', isProd: true }
        ];
    }
    deployedEnvs(deployableItem) {
        const deployedEnv = _.mapValues(deployableItem.released_content, v => {
            return v?.LASTED?.released_at ? dayjs(v.LASTED.released_at).isAfter(dayjs(deployableItem.updated_at)) : false;
        });
        const sortedEnvs = _.map(this.getEnvironmentList(), 'value');
        const deployEnvStatusMap = _.zipObject(sortedEnvs, _.fill(Array(sortedEnvs.length), ''));
        _.forEach(deployedEnv, (v, k) => {
            deployEnvStatusMap[k] = v ? 'new' : 'old';
        });
        return deployEnvStatusMap;
    }
};
DeployableManagementService = __decorate([
    injectable()
], DeployableManagementService);
export { DeployableManagementService };
